<template>
  <nav v-if="activePageCode !== 'landing'" class="fade-in topbar columns is-mobile" role="navigation" aria-label="main navigation">
    <div class="topbar-left">
      <icon class="top-bar-svg fill-niras-red" name="niraslogo"></icon>
      <div v-if="project && project.contentJson && activePageCode !== 'project'" @click="openModal('edit-project-modal', project)" class="project-info">
        <div class="project-title">
          <span>{{project.contentJson.name}}</span>
        </div>
        <div class="project-author">
          <span>{{project.contentJson.customer}}</span>
        </div>
      </div>
    </div>
    <div class="topbar-center">
      <h1 id="topbar-center-item">{{dynamicHeader}}</h1>
    </div>
    <div class="topbar-right save-button-container flex-inline-base">
      <button v-if="activePageCode === 'results'" class="flex-align-center button pdf-button" @click="makePDF()">
        <icon class="small-svg fill-white flex" name="pdf-file"></icon>
        <span>{{$t('top-bar.export')}}</span>
      </button>
      <button v-if="activePageCode !== 'project'" class="flex-align-center button save-button" @click="openModal('save-modal')">
        <icon class="small-svg fill-white flex" name="cloud-download"></icon>
        <span>{{$t('top-bar.saveButton')}}</span>
      </button>
      <button v-if="activePageCode === 'project'" class="flex-align-center button save-button" @click="openModal('edit-project-modal')">
        <icon class="small-svg fill-white flex" name="add"></icon>
        <span>{{$t('modal-project.modalButtonlabelNewProject')}}</span>
      </button>
    </div>
  </nav>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'top-bar',
  computed: {
    ...mapGetters({
      project: 'getProject',
      activePageCode: 'getActivePageCode',
      activePageViewContext: 'getActivePageViewContext'
    }),
    dynamicHeader () {
      if (this.activePageCode === 'project') {
        return this.$t('modal-project.modalProjectTitle')
      }
      if (this.activePageCode === 'goals') {
        return this.$t('goals.pageTitle')
      }
      if (this.activePageCode === 'tasks') {
        return this.$t('tasks.pageTitle')
      }
      if (this.activePageCode === 'results' && this.activePageViewContext === 'results') {
        return this.$t('results.pageTitle')
      }
      if (this.activePageCode === 'results' && this.activePageViewContext === 'history') {
        return this.$t('history.pageTitle')
      }
      return ''
    }
  },
  methods: {
    ...mapActions({
      setShowModal: 'setShowModal',
      setModalType: 'setModalType',
      setModalData: 'setModalData',
      setCreatePDF: 'setCreatePDF'
    }),
    openModal (type, data) {
      this.setShowModal(true)
      this.setModalType(type)
      this.setModalData(data)
    },
    centerMiddleItem () {
      let item = document.getElementById('topbar-center-item')

      let wantedLeft = (item.parentElement.parentElement.offsetWidth - item.offsetWidth) / 2

      if (wantedLeft > item.parentElement.offsetLeft) {
        item.style.marginLeft = wantedLeft - item.parentElement.offsetLeft + 'px'
      } else {
        item.style.marginLeft = '0px'
      }
    },
    makePDF () {
      this.setCreatePDF(true)
    }
  },
  watch: {
    activePageCode (val) {
      if (val !== 'landing') {
        this.$nextTick(() => {
          this.centerMiddleItem()
        })
      }
    }
  },
  mounted () {
    this.centerMiddleItem()
    window.addEventListener('resize', this.centerMiddleItem)
  }
}
</script>
